import { render, staticRenderFns } from "./FacturasYNCTableActions.vue?vue&type=template&id=2d0d4189"
import script from "./FacturasYNCTableActions.vue?vue&type=script&lang=js"
export * from "./FacturasYNCTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports